import {
    ServiceAssertionPerformanceComparisonReferenceData,
    ServiceAssertionPerformanceComparisonSearchFiltersState
} from "@idw-types/state/service-assertion-performance-comparison-state";
import { FormattedServiceAssertionPerformance } from "@idw-types/data/reports";

export enum ServiceAssertionPerformanceComparisonActionTypes {
    // Reference Data
    SET_SERVICE_ASSERTION_PERFORMANCE_COMPARISON_REFERENCE_DATA_LOADING = "SET_SERVICE_ASSERTION_PERFORMANCE_COMPARISON_REFERENCE_DATA_LOADING",
    SET_SERVICE_ASSERTION_PERFORMANCE_COMPARISON_REFERENCE_DATA = "SET_SERVICE_ASSERTION_PERFORMANCE_COMPARISON_REFERENCE_DATA",
    // Search
    SET_SERVICE_ASSERTION_PERFORMANCE_COMPARISON_SEARCH_FILTERS = "SET_SERVICE_ASSERTION_PERFORMANCE_COMPARISON_SEARCH_FILTERS",
    SET_SERVICE_ASSERTION_PERFORMANCE_COMPARISON_SEARCH_RESULTS_LOADING = "SET_SERVICE_ASSERTION_PERFORMANCE_COMPARISON_SEARCH_RESULTS_LOADING",
    SET_SERVICE_ASSERTION_PERFORMANCE_COMPARISON_SEARCH_RESULTS = "SET_SERVICE_ASSERTION_PERFORMANCE_COMPARISON_SEARCH_RESULTS"
}

// Reference Data
type SetServiceAssertionPerformanceComparisonReferenceDataLoadingAction = {
    type: ServiceAssertionPerformanceComparisonActionTypes.SET_SERVICE_ASSERTION_PERFORMANCE_COMPARISON_REFERENCE_DATA_LOADING,
    payload: { isLoading: boolean }
};

export const setServiceAssertionPerformanceComparisonReferenceDataLoading = (isLoading: boolean): SetServiceAssertionPerformanceComparisonReferenceDataLoadingAction => ({
    type: ServiceAssertionPerformanceComparisonActionTypes.SET_SERVICE_ASSERTION_PERFORMANCE_COMPARISON_REFERENCE_DATA_LOADING,
    payload: { isLoading }
});

type SetServiceAssertionPerformanceComparisonReferenceDataAction = {
    type: ServiceAssertionPerformanceComparisonActionTypes.SET_SERVICE_ASSERTION_PERFORMANCE_COMPARISON_REFERENCE_DATA,
    payload: { referenceData: ServiceAssertionPerformanceComparisonReferenceData; }
};

export const setServiceAssertionPerformanceComparisonReferenceData = (referenceData: ServiceAssertionPerformanceComparisonReferenceData): SetServiceAssertionPerformanceComparisonReferenceDataAction => ({
    type: ServiceAssertionPerformanceComparisonActionTypes.SET_SERVICE_ASSERTION_PERFORMANCE_COMPARISON_REFERENCE_DATA,
    payload: { referenceData }
});

// Search
type SetServiceAssertionPerformanceComparisonSearchFiltersAction = {
    type: ServiceAssertionPerformanceComparisonActionTypes.SET_SERVICE_ASSERTION_PERFORMANCE_COMPARISON_SEARCH_FILTERS;
    payload: { searchFilters: ServiceAssertionPerformanceComparisonSearchFiltersState };
};

export const setServiceAssertionPerformanceComparisonSearchFilters = (
    searchFilters: ServiceAssertionPerformanceComparisonSearchFiltersState
): SetServiceAssertionPerformanceComparisonSearchFiltersAction => ({
    type: ServiceAssertionPerformanceComparisonActionTypes.SET_SERVICE_ASSERTION_PERFORMANCE_COMPARISON_SEARCH_FILTERS,
    payload: { searchFilters }
});

type SetServiceAssertionPerformanceComparisonSearchResultsLoadingAction = {
    type: ServiceAssertionPerformanceComparisonActionTypes.SET_SERVICE_ASSERTION_PERFORMANCE_COMPARISON_SEARCH_RESULTS_LOADING;
    payload: { isLoading: boolean };
};

export const setServiceAssertionPerformanceComparisonSearchResultsLoading = (isLoading: boolean): SetServiceAssertionPerformanceComparisonSearchResultsLoadingAction => ({
    type: ServiceAssertionPerformanceComparisonActionTypes.SET_SERVICE_ASSERTION_PERFORMANCE_COMPARISON_SEARCH_RESULTS_LOADING,
    payload: { isLoading }
});

type SetServiceAssertionPerformanceComparisonSearchResultsAction = {
    type: ServiceAssertionPerformanceComparisonActionTypes.SET_SERVICE_ASSERTION_PERFORMANCE_COMPARISON_SEARCH_RESULTS;
    payload: { serviceAssertionPerformances: Array<FormattedServiceAssertionPerformance> };
};

export const setServiceAssertionPerformanceComparisonSearchResults = (
    serviceAssertionPerformances: Array<FormattedServiceAssertionPerformance>
): SetServiceAssertionPerformanceComparisonSearchResultsAction => ({
    type: ServiceAssertionPerformanceComparisonActionTypes.SET_SERVICE_ASSERTION_PERFORMANCE_COMPARISON_SEARCH_RESULTS,
    payload: { serviceAssertionPerformances }
});

export type ServiceAssertionPerformanceComparisonActions =
    // Reference Data
    SetServiceAssertionPerformanceComparisonReferenceDataLoadingAction |
    SetServiceAssertionPerformanceComparisonReferenceDataAction |
    // Search
    SetServiceAssertionPerformanceComparisonSearchFiltersAction |
    SetServiceAssertionPerformanceComparisonSearchResultsLoadingAction |
    SetServiceAssertionPerformanceComparisonSearchResultsAction